import type {ReactAction} from '@netx/core/bootstrap';
import {faStar} from '@fortawesome/pro-solid-svg-icons';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionToggleFavoriteIcon = faStar;

/**
 * Saved search toggle favorite
 * @param params
 * @returns Action
 */
export const searchSavedActionToggleFavorite = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-toggle-favorite',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.TOGGLE_FAVORITE, savedSearch),
	icon: searchSavedActionToggleFavoriteIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.TOGGLE_FAVORITE;
	},
	...params,
});

export default searchSavedActionToggleFavorite;
